import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import api from "../../services/api";
import { showError } from "../../services/alert";
import { useNavigate } from "react-router-dom";

const RelAplicacaoInsumo = () => {
  const [safras, setSafras] = useState([]);
  const [safraId, setSafraId] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadSafras = async () => {
      try {
        const res = await api.get("/safras");
        setSafras(res.data);
      } catch {
        showError("Erro ao carregar safras.");
      }
    };
    loadSafras();
  }, []);

  const handleDownload = async (tipo) => {
    if (!safraId) {
      showError("Selecione uma safra primeiro.");
      return;
    }

    const url = `/relatorios/agricola/aplicacoes/${safraId}/${tipo}`;
    try {
      setLoading(true);
      const response = await api.get(url, {
        responseType: tipo === "json" ? "json" : "blob",
      });

      if (tipo === "json") {
        console.log("Dados JSON:", response.data);
        alert("JSON carregado no console.");
        return;
      }

      const blob = new Blob([response.data], {
        type: tipo === "pdf" ? "application/pdf" : "text/csv",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download =
        tipo === "pdf"
          ? `RelatorioAplicacoes_${safraId}.pdf`
          : `RelatorioAplicacoes_${safraId}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Erro ao gerar relatório:", err);
      showError("Erro ao gerar relatório.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex align-items-center justify-content-between rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate("/menu")}
              disabled={loading}
            >
              <i className="bi bi-arrow-left text-success" />
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Relatório de Aplicações de Insumos</h5>
              <small className="text-white-50">
                Exporte os dados de insumos aplicados na safra
              </small>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Safra</label>
              <select
                className="form-select"
                value={safraId}
                onChange={(e) => setSafraId(e.target.value)}
              >
                <option value="">Selecione...</option>
                {safras.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.cultura} -{" "}
                    {new Date(s.dataPlantio).toLocaleDateString("pt-BR")}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6 d-flex gap-2">
              <button
                className="btn btn-outline-success"
                disabled={loading}
                onClick={() => handleDownload("pdf")}
              >
                <i className="bi bi-file-earmark-pdf"></i> PDF
              </button>
              <button
                className="btn btn-outline-primary"
                disabled={loading}
                onClick={() => handleDownload("csv")}
              >
                <i className="bi bi-filetype-csv"></i> CSV
              </button>
              <button
                className="btn btn-outline-secondary"
                disabled={loading}
                onClick={() => handleDownload("json")}
              >
                <i className="bi bi-code-slash"></i> JSON
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelAplicacaoInsumo;
